"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Checkbox_1 = __importDefault(require("@Components/Selectors/Checkbox"));
const user_permissions_1 = require("@App/enum/user-permissions");
const MyUserGroupsMapped = (props) => {
    const { myUserGroups, editIsDisabled, setMyUserGroups, rightsholderUser, setEditActionsGroups } = props;
    const superUserChecked = (superUserIsChecked, newMyUserGroups) => {
        const myUserGroupsMapped = newMyUserGroups.map((item) => {
            const otherItemsChecked = superUserIsChecked ? false : item.checked;
            return Object.assign(Object.assign({}, item), { checked: item.name === user_permissions_1.PERMISSION_NAMES.super_user ? superUserIsChecked : otherItemsChecked, disabled: item.name !== user_permissions_1.PERMISSION_NAMES.super_user && superUserIsChecked });
        });
        setMyUserGroups(myUserGroupsMapped);
        editActionsGroupsUpdate(myUserGroupsMapped);
    };
    const editActionsGroupsUpdate = (newMyUserGroups) => {
        var _a;
        const newEditActionsGroups = [];
        const initData = rightsholderUser;
        let editActionsGroupsFiltered;
        if ((_a = initData.groups) === null || _a === void 0 ? void 0 : _a.length) {
            editActionsGroupsFiltered = newMyUserGroups.filter((item) => {
                var _a;
                const indexGroupFromPermission = (_a = initData.groups) === null || _a === void 0 ? void 0 : _a.findIndex((group) => group.name === item.name);
                if (indexGroupFromPermission !== -1 && item.checked) {
                    return false;
                }
                else if (indexGroupFromPermission === -1 && !item.checked) {
                    return false;
                }
                return true;
            });
        }
        else {
            editActionsGroupsFiltered = newMyUserGroups;
        }
        newEditActionsGroups.push(...editActionsGroupsFiltered);
        setEditActionsGroups([...new Set(newEditActionsGroups)]);
    };
    const onCheckGroup = (index) => {
        const newMyUserGroups = [...myUserGroups];
        newMyUserGroups[index].checked = !newMyUserGroups[index].checked;
        const superUserIsChecked = newMyUserGroups[index].name === user_permissions_1.PERMISSION_NAMES.super_user && newMyUserGroups[index].checked;
        superUserChecked(superUserIsChecked, newMyUserGroups);
    };
    return (react_1.default.createElement("div", { className: 'permissions-group' }, myUserGroups.map((item, index) => {
        if (item.name !== 'Internal User') {
            return (react_1.default.createElement(Checkbox_1.default, { key: item.name, id: item.name, mainColor: true, onClick: () => onCheckGroup(index), checked: item.checked, text: item.name, disabled: editIsDisabled ? editIsDisabled : item.disabled }));
        }
        else {
            return null;
        }
    })));
};
exports.default = MyUserGroupsMapped;
